import http from '../http'

/**
 * 用户相关接口
 */
const userApi = {
  /**
   * 获取手机验证码
   * @param {Object} params - 获取手机验证码 {phone}
   * @returns {Promise}
   */
  getPhoneCode(params) {
    return http.get('/sendSms', params)
  },

  /**
   * 登录
   * @param {Object} params - 登录 {phone, code}
   * @returns {Promise}
   */
  login(params) {
    return http.get('/webLogin', params)
  },

  /**
   * 获取用户信息
   * @returns {Promise}
   */
  getUserInfo() {
    return http.get('/wxuser/wxuser/getUserInfo')
  },

  /**
   * 更新用户信息
   * @param {Object} params - 用户信息
   * @returns {Promise}
   */
  updateUserInfo(params) {
    return http.post('/wxuser/wxuser/updateUser', params)
  },

  /**
   * 退出登录
   * @returns {Promise}
   */
  logout() {
    return http.post('/user/logout')
  },

  /**
   * 获取服务结余
   * @returns {Promise}
   */
  getUserBalance() {
    return http.get('/system/order/fwjy')
  },
  /**
   * 我的订单
   * @returns {Promise}
   */
  getMyOrder(params) {
    return http.get('/system/order/myOrderList',params)
  },

  /**
   * 我的订单详情
   * @returns {Promise}
   */
  getMyOrderDetail(params) {  
    return http.get('/system/order/getById',params)
  },

  /**
   * 我的下载
   * @returns {Promise}
   */
  getMyDownload(params) {
    return http.get('/system/orderBook/userBookDown',params)
  },
  /**
   * 我的优惠券
   * @returns {Promise}
   */
  getMyCoupon(params) {
    return http.get('/system/userCoupon/list',params)
  },
  /**
   * 我的律师
   * @returns {Promise}
   */
  getMyLawyer(params) {
    return http.get('/system/order/myLs',params)
  },
  /**
   * 我的律师详情
   * @returns {Promise}
   */
  getMyLawyerDetail(params) {
    return http.get('/wxuser/wxuser/getById',params)
  },
  /**
   * 我的团队
   * @returns {Promise}
   */
  getMyTeam(params) {
    return http.get('/wxuser/wxuser/getCompanyUsers',params)
  },
  /**
   * 移除团队成员
   * @returns {Promise}
   */
  removeMyTeam(params) {
    return http.get('/wxuser/wxuser/delCompanyUser',params)
  },
  /**
   * 获取企业列表
   * @returns {Promise}
   */
  getCompanyList(data) {
    return http.post('/wxuser/wxuser/chooseCompanyList',data)
  },
  /**
   * 加入企业
   * @returns {Promise}
   */
  joinCompany(params) {
    return http.get('/wxuser/wxuser/userJoinCompany',params)
  },
  /**
   * 提交审批
   * @returns {Promise}
   */
  submitApproval(params) {
    return http.post('/wxuser/wxuser/userJoinLs',params)
  },
  /**
   * 我的服务列表
   * @returns {Promise}
   */
  getMyServiceList(params) {
    return http.get('/system/order/lsOrderList',params)
  },
  /**
   * 获取收入列表
   * @returns {Promise}
   */
  getIncomeList(params) {
    return http.get('/system/orderJiesuan/getUserJieusan',params)
  },
  /**
   * 获取收入金额
   * @returns {Promise}
   */
  getIncomeAmount(params) {
    return http.get('/system/orderJiesuan/getUserJieusanCount',params)
  },
  /**
   * 获取我的视频分类列表
   * @returns {Promise}
   */
  getMyVideoCategoryList(params) {
    return http.get('/system/videoCategory/list',params)
  },
  /**
   * 获取我的视频列表
   * @returns {Promise}
   */
  getMyVideoList(params) {
    return http.get('/system/video/lslist',params)
  },
  /**
   * 新增视频
   * @returns {Promise}
   */
  addVideo(params) {
    return http.post('/system/video/doAddByLs',params)
  },
  /**
   * 提交服务
   * @returns {Promise}
   */
  submitService(params) {
    return http.post('/system/order/orderdetailChange',params)
  },
  /**
   * 获取我的发票列表
   * @returns {Promise}
   */
  getMyInvoiceList(params) {
    return http.get('/system/orderFp/myFp',params)
  },
  /**
   * 申请开票
   * @returns {Promise}
   */
  applyInvoice(params) {
    return http.post('/system/orderFp/doAdd',params)
  },
   /**
   * 判断用户是否是管理员
   * @returns {Promise}
   */
   justGlyApi(params) {
    return http.get('/wxuser/wxuser/getUserIsAdmin',params)
  },
  /**
   * 设置为管理员
   * @returns {Promise}
   */
  setGlyApi(params) {
    return http.get('/wxuser/wxuser/setCompanyAdmin',params)
  },
}
export default userApi 